import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Usuarios';

export interface Usuario {
	login: string;
	nombre: string;
	idPerfil: string;
	perfil: string;
	email: string;
	centros: string;
	tieneCentros: boolean;
}

export interface Perfil {
  idPerfil: string;
  perfil: string;
}

export class UsuariosAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarUsuarios(): AxiosPromise<Usuario[]> {
		return this.cliente.get(`/ListarUsuarios`);
	}

	CrearUsuario(usuario:any): AxiosPromise<Usuario[]> {
		return this.cliente.post(usuario, `/CrearUsuario`);
	}

	EliminarUsuario(login:string): AxiosPromise<any> {
		return this.cliente.remove(login, `/EliminarUsuario`);
	}

	ModificarUsuario(loginOLD:string,usuario: any): AxiosPromise<any[]> {
		return this.cliente.put(loginOLD, usuario, `/ModificarUsuario`);
	}

	ListarPerfiles(): AxiosPromise<Perfil[]> {
		return this.cliente.get(`/ListarPerfiles`);
	}

	AgregarCentrosUsuario(loginUser:string,centros:string): AxiosPromise<Usuario[]> {
		const data = {login:loginUser,centros:centros}
		return this.cliente.post(data, `/AgregarCentrosUsuario`);
	}
}